import { useId } from "react";
import "./tasks.css";

interface TaskFlameProps {
  className?: string;
  /** false = flamme fixe (bouton, listes). */
  animated?: boolean;
  /** Variante blanche pour fond coloré. */
  tone?: "fire" | "white";
}

/** Flamme dessinée (pas d'emoji) : vacille doucement, immobile si l'utilisateur réduit les animations. */
export function TaskFlame({ className = "h-4 w-4", animated = true, tone = "fire" }: TaskFlameProps) {
  const gradientId = useId();
  const outer = tone === "white" ? "#ffffff" : `url(#${gradientId})`;
  const inner = tone === "white" ? "rgba(255,255,255,0.55)" : "#FDE68A";
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false">
      {tone === "fire" && (
        <defs>
          <linearGradient id={gradientId} x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#DC2626" />
            <stop offset="55%" stopColor="#F97316" />
            <stop offset="100%" stopColor="#FBBF24" />
          </linearGradient>
        </defs>
      )}
      <g className={animated ? "task-flame" : undefined}>
        <path
          fill={outer}
          d="M12.6 1.8c.4 3.1-1.3 4.9-3 6.7C7.8 10.4 6 12.3 6 15.3 6 19 8.7 22 12 22s6-2.8 6-6.6c0-2.5-1.2-4.2-2.3-5.6-.2 1.3-.8 2.3-1.7 2.9.3-3.8-.3-8.2-1.4-10.9Z"
        />
        <path
          className={animated ? "task-flame-core" : undefined}
          fill={inner}
          d="M12.2 12.6c-.1 1.4-.9 2.2-1.6 3-.6.7-1.1 1.4-1.1 2.4 0 1.5 1.1 2.6 2.5 2.6s2.5-1.1 2.5-2.6c0-1.8-1.1-3.6-2.3-5.4Z"
        />
      </g>
    </svg>
  );
}
